import { render } from "./MoreInformation.vue?vue&type=template&id=7c4bb82c&scoped=true"
import script from "./MoreInformation.vue?vue&type=script&lang=js"
export * from "./MoreInformation.vue?vue&type=script&lang=js"

import "./MoreInformation.vue?vue&type=style&index=0&id=7c4bb82c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4bb82c"]])

export default __exports__